const config = {
  initiateLoginEndpoint: import.meta.env.VITE_START_LOGIN_PAGE_URL,
  clientId: import.meta.env.VITE_CLIENT_ID,
  apiEndpoint: import.meta.env.VITE_FUNC_ENDPOINT,
  apiName: import.meta.env.VITE_FUNC_NAME,
  // Teams Web Client ID (Microsoft's official client ID)
  teamsWebClientId: '5e3ce6c0-2b1f-4285-8d4b-75ee78787346',
  // API scopes for backend authentication - use delegated scope for user consent
  apiScope: import.meta.env.VITE_M365_APPLICATION_ID_URI ? 
    `${import.meta.env.VITE_M365_APPLICATION_ID_URI}/access_as_user` : 
    `api://app.izzygo.pro/${import.meta.env.VITE_CLIENT_ID}/access_as_user`
};

export default config;
